import { render } from "./ReportsContainer.vue?vue&type=template&id=5364806e&scoped=true"
import script from "./ReportsContainer.vue?vue&type=script&lang=js"
export * from "./ReportsContainer.vue?vue&type=script&lang=js"

import "./ReportsContainer.vue?vue&type=style&index=0&id=5364806e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5364806e"]])

export default __exports__